
export function _setTerminalListArray(state, responseData) {
    state.terminalList = responseData
}

